import React from 'react';
import { Box, Container, Typography, Paper, } from '@mui/material';
import { motion } from 'framer-motion';
import StarIcon from '@mui/icons-material/Star';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TestimonialsSection = () => {
  return (
    <>
      <style>
        {`
          .slick-slider {
            position: relative;
          }
          .slick-list {
            margin: 0 -12px;
          }
          .slick-slide {
            height: auto;
          }
          .slick-slide > div {
            padding: 0 12px;
            height: 100%;
            display: flex;
          }
          .slick-track {
            display: flex;
            align-items: stretch;
          }
          .slick-dots {
            bottom: -40px;
          }
        `}
      </style>
      <Box
        sx={{
          width: '100vw',
          py: { xs: 8, md: 12 },
          background: 'linear-gradient(180deg, #0F0F1A 0%, #1A0F2A 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          px: 0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: { xs: '20px', sm: '120px', md: '200px' },
            background: 'linear-gradient(90deg, rgba(15, 15, 26, 0.6) 0%, rgba(15, 15, 26, 0.3) 40%, rgba(15, 15, 26, 0) 100%)',
            backdropFilter: 'blur(3px)',
            zIndex: 2,
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: { xs: '20px', sm: '120px', md: '200px' },
            background: 'linear-gradient(270deg, rgba(15, 15, 26, 0.6) 0%, rgba(15, 15, 26, 0.3) 40%, rgba(15, 15, 26, 0) 100%)',
            backdropFilter: 'blur(3px)',
            zIndex: 2,
            pointerEvents: 'none',
          }}
        />
        <Container maxWidth="xl" sx={{ px: 0 }}>
          <Box
            sx={{
              textAlign: 'center',
              mb: { xs: 6, md: 8 },
              px: { xs: 2, sm: 3, md: 4 },
            }}
          >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Box
              sx={{
                display: 'inline-block',
                mb: 3,
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 600,
                  fontSize: '24px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  color: '#FFFFFF',
                  background: 'linear-gradient(180deg, #8125F9 0%, #4649FB 100%)',
                  opacity: 0.8,
                  borderRadius: '40px',
                  px: 3,
                  py: 1.5,
                  display: 'inline-block',
                }}
              >
                Testimonials
              </Typography>
            </Box>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Sora, sans-serif',
                fontWeight: 600,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem', lg: '44px' },
                lineHeight: '160%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#C2C4C8',
              }}
            >
              What Our Customers Ship with Us
            </Typography>
          </motion.div>
        </Box>

        {(() => {
          const testimonials = [
            {
              name: 'Sarah Mitchell',
              title: 'Product Designer · TechFlow',
              testimonial: 'The attention to detail and quality of work exceeded our expectations. Our conversion rate improved by 40% after the redesign.',
              avatar: 'https://i.pravatar.cc/150?img=45',
            },
            {
              name: 'James Chen',
              title: 'CEO · StartupHub',
              testimonial: 'Working with this team transformed our entire digital presence. They understood our vision perfectly and delivered beyond expectations.',
              avatar: 'https://i.pravatar.cc/150?img=12',
            },
            {
              name: 'Emily Rodriguez',
              title: 'Marketing Director · GrowthLabs',
              testimonial: 'Exceptional service from start to finish. The results speak for themselves - our engagement metrics doubled in just three months.',
              avatar: 'https://i.pravatar.cc/150?img=47',
            },
            {
              name: 'Sarah Mitchell',
              title: 'Product Designer · TechFlow',
              testimonial: 'The attention to detail and quality of work exceeded our expectations. Our conversion rate improved by 40% after the redesign.',
              avatar: 'https://i.pravatar.cc/150?img=45',
            },
            {
              name: 'Emily Rodriguez',
              title: 'Marketing Director · GrowthLabs',
              testimonial: 'Exceptional service from start to finish. The results speak for themselves - our engagement metrics doubled in just three months.',
              avatar: 'https://i.pravatar.cc/150?img=47',
            },
            {
              name: 'Michael Thompson',
              title: 'Founder · InnovateCo',
              testimonial: 'A game-changer for our business. Professional, always delivered on time. Couldn\'t ask for a better partnership.',
              avatar: 'https://i.pravatar.cc/150?img=13',
            },
          ];

          const renderCard = (testimonial, index, uniqueKey) => (
            <Box key={uniqueKey !== undefined ? uniqueKey : index} sx={{ px: 1.5, height: '100%', display: 'flex' }}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                style={{ width: '100%', height: '100%', display: 'flex' }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    background: 'linear-gradient(135deg, rgba(45, 46, 47, 0.5) 0%, rgba(15, 23, 43, 0.5) 100%)',
                    borderTop: '1px solid #31415880',
                    borderRadius: '24px',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    p: 3,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                    <Box
                      component="img"
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        background: '#FFFFFF00',
                        boxShadow: '0px 0px 0px 2px #314158',
                        objectFit: 'cover',
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        sx={{
                          fontFamily: 'Sora, sans-serif',
                          fontWeight: 400,
                          fontSize: '16px',
                          lineHeight: '24px',
                          letterSpacing: '-0.31px',
                          color: '#FFFFFF',
                          mb: 0.5,
                        }}
                      >
                        {testimonial.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: 'Manrope, sans-serif',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '20px',
                          letterSpacing: '-0.15px',
                          color: '#90A1B9',
                          mb: 1.5,
                        }}
                      >
                        {testimonial.title}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <StarIcon
                            key={star}
                            sx={{
                              color: '#FFD700',
                              fontSize: 18,
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: 'Manrope, sans-serif',
                      fontWeight: 400,
                      fontSize: '16px',
                      lineHeight: '26px',
                      letterSpacing: '-0.31px',
                      color: '#CAD5E2',
                      mt: 2,
                      flex: 1,
                    }}
                  >
                    {testimonial.testimonial}
                  </Typography>
                </Paper>
              </motion.div>
            </Box>
          );

          const sliderSettings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 960,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          };

          return (
            <>
              <Box sx={{ mt: 4, px: { xs: 2, sm: 3, md: 4 }, ml: { xs: -1, sm: -4, md: -6 } }}>
                <Slider {...sliderSettings}>
                  {testimonials.slice(0, 3).map((testimonial, index) => renderCard(testimonial, index, index))}
                </Slider>
              </Box>
              {/* <Box sx={{ mt: 3, px: { xs: 2, sm: 3, md: 4 } }}>
                <Slider {...sliderSettings}>
                  {[...testimonials.slice(3, 6), ...testimonials.slice(3, 6)].map((testimonial, index) => renderCard(testimonial, index % 3, `second-${index}`))}
                </Slider>
              </Box> */}
            </>
          );
        })()}
        </Container>
      </Box>
    </Box>
    </>
  );
};

export default TestimonialsSection;

